import { render, staticRenderFns } from "./StudySetDuplicateDetail.vue?vue&type=template&id=8bf75c7a&scoped=true&"
import script from "./StudySetDuplicateDetail.vue?vue&type=script&lang=js&"
export * from "./StudySetDuplicateDetail.vue?vue&type=script&lang=js&"
import style0 from "./StudySetDuplicateDetail.vue?vue&type=style&index=0&id=8bf75c7a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8bf75c7a",
  null
  
)

export default component.exports